import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Configuration} from '@shared/models/configuration';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {DeleteReportTaskCommand} from '@features/data-survey/commands/survey.commands';
import {take, takeUntil} from 'rxjs/operators';
import {TaskManagerService} from '@features/task-manager/services/task-manager.service';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ReportTaskContentHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  sourceKey = 'Generic-Report-Task';

  constructor(private taskManagerService: TaskManagerService, private commandService: CommandService, private router: Router,) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand) {
    if (command.name === 'ReportAddTask') {
      const reportId = this.magicLinkModel.fieldValues['ReportId'];
      this.router.navigateByUrl(`dac6-reporter/reports/${reportId}/add-task`);
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    const reportId = this.magicLinkModel.fieldValues['ReportId'];
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['REPORT_ID'] = reportId;
    Configuration.setSmartGridConfig(this.sourceKey, config);
  }

  valueChanged($event) {
    console.log($event);
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'NotificationStatus') {
      this.taskManagerService.openTaskByTaskId($event.item.cells['Task'].value.ticketId, GraphqlContentScope.getScope($event.item.cells['Task'].value.boardScope), null, null, {
        id: 'TaskAlert',
        input: {selectedNotificationTab: 1}
      });
      return;
    }
    if ($event.action) {
      switch ($event.action.id) {
        case 'Delete':
          const command = new DeleteReportTaskCommand($event.item.id);
          this.commandService.executeCommand(command).pipe(take(1)).subscribe(state => {
            this.invalidateSubject.invalidate();
          });
          break;
        case 'SendNow':
          break;
        case 'TaskClosed':
          this.invalidateSubject.invalidate();
          break;
      }
    }
  }

}
